import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthServices from "../../services/AuthServices";
import { message } from "antd";
import { decodeToken } from "react-jwt";
import _ from "lodash";

const CallbackSSO = ({ onSuccess }) => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const roleAllowed = (roles) => {
    const allow = [
      "eira-super-admin",
      "eira-company-admin",
      "eira-company-coordinator",
      "eira-professional",
    ];

    return _.intersection(allow, roles).length > 0;
  };

  const processResponse = async (data, decodedToken) => {
    const ssoClientId = process.env.REACT_APP_SSO_CLIENT_ID;
    if (roleAllowed(decodedToken.resource_access[ssoClientId]?.roles || [])) {
      AuthServices.setRemember(true);
      AuthServices.setToken(data.access_token);
      AuthServices.setRefreshToken(data.refresh_token);
      AuthServices.setUser(decodedToken.preferred_username);
      if (onSuccess) {
        await onSuccess();
      }
      navigate("/admin");
    } else {
      setError("No tienes permisos para ingresar.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError("");
      if (!code.trim()) {
        setError("Código incorrecto.");
        return;
      }
      try {
        const res = await AuthServices.keycloakLoginSSO(code.trim());
        if (
          res?.status !== undefined &&
          res.status >= 200 &&
          res.status < 300 &&
          res.data
        ) {
          const decodedToken = decodeToken(res.data.access_token);
          processResponse(res.data, decodedToken);
        } else {
          setError("Código incorrecto.");
        }
        setLoading(false);
      } catch {
        message.error(
          "Error al iniciar sesión. Por favor, intente nuevamente."
        );
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <h1>Inicio de sesión con Azure Adium</h1>
      {loading && <p>Cargando...</p>}
      {error && <p>{error}</p>}
    </div>
  );
};

export default CallbackSSO;
